var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIls146(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 126,
    viewBox: "0 0 63 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4257 18.0788L31.4613 35.9543L0.478027 18.0883L31.4613 0.212769L62.4257 18.0788Z",
    fill: "url(#paint0_linear_724_4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4257 18.0789V107.513L31.4424 125.379L31.4613 35.9543L62.4257 18.0789Z",
    fill: "#F3F6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 125.379L0.478027 107.494V18.0883L31.4613 35.9543L31.4424 125.379Z",
    fill: "url(#paint1_linear_724_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_724_4",
    x1: 62.4254,
    y1: 18.0864,
    x2: 0.477931,
    y2: 18.0864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_724_4",
    x1: 31.4607,
    y1: 71.7336,
    x2: 0.477933,
    y2: 71.7336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls146);
export default __webpack_public_path__ + "static/media/ils_14_6.41468451a3e65b284affd8ab0002c555.svg";
export { ForwardRef as ReactComponent };